import {createAnchor} from "./create/create-ahchor";
import {createButton} from "./create/create-button";
import {createImage} from "./create/create-image";
import {createList} from "./create/create-list";
import {createListItem} from "./create/create-list-item";

const SUBITEM_COUNT = 8;

export const renderCatalogPage = (catalogList) => {
  const catalogPageElement = document.querySelector(`.catalog-page`);

  if (!catalogPageElement) {
    return;
  }

  const catalogPageListElement = catalogPageElement.querySelector(`.catalog-page__list`);

  Object.keys(catalogList)
  .filter((key) => key !== `current`)
  .forEach((itemId) => {
    const liItemElement = createListItem(`catalog-page__item`);

    const anchorElement = createAnchor(`catalog-page__itemLink`, catalogList[itemId].name, catalogList[itemId].link);
    liItemElement.append(anchorElement);

    const imgElement = createImage(`catalog-page__itemIcon`, catalogList[itemId].icon, ``);
    imgElement.width = `30`;
    imgElement.height = `30`;
    anchorElement.append(imgElement);

    const subListElement = createList(`catalog-page__sublist`);
    liItemElement.append(subListElement);

    const subCatalogList = catalogList[itemId].subgroup;

    Object.keys(subCatalogList)
      .forEach((subItemId, i) => {
        const subItemElement = createListItem(`catalog-page__subitem ${i > SUBITEM_COUNT - 1 ? `catalog-page__subitem--hide` : ``}`);
        const subAnchorElement = createAnchor(`catalog-page__sublink`, subCatalogList[subItemId].name, subCatalogList[subItemId].link);

        subItemElement.append(subAnchorElement);
        subListElement.append(subItemElement);
      });

    if (Object.keys(subCatalogList).length > SUBITEM_COUNT) {
      const buttonElement = createButton(`Показать все`, `catalog-page__showButton`);
      buttonElement.dataset.mode = `show`;

      buttonElement.addEventListener(`click`, () => {
        const subItemElements = subListElement.querySelectorAll(`.catalog-page__subitem`);

        if (buttonElement.dataset.mode === `show`) {
          subItemElements.forEach((elem) => {
            elem.classList.remove(`catalog-page__subitem--hide`);
          });

          buttonElement.dataset.mode = `hide`;
          buttonElement.innerHTML = `Скрыть`;

          return;
        }

        if (buttonElement.dataset.mode === `hide`) {
          const hideSubItemElements = Array.from(subItemElements).slice(8);

          hideSubItemElements.forEach((elem) => {
            elem.classList.add(`catalog-page__subitem--hide`);
          });

          buttonElement.dataset.mode = `show`;
          buttonElement.innerHTML = `Показать все`;
        }
      });

      liItemElement.append(buttonElement);
    }

    catalogPageListElement.append(liItemElement);
  });
};
